import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
  FormGroup,
  CustomInput,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import { withRouter } from "react-router";

import apiResponse from "../../../../services/apiResponse";

import UpdateBloc from "./Blocs/UpdateBloc";

class IndexView extends Component {
  updateBloc = new UpdateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
    };
  }

  submitData = async () => {
    await this.updateBloc.fetchUpdate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        uuid: this.state.dataForm.rank_uuid,
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.updateBloc.updateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.updateBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              dataForm: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    const queryParams = new URLSearchParams(this.props.location.search);
    this.updateBloc.fetchDetail({ uuid: queryParams.get("uuid") });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Edit Pangkat</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="rank_name"
                        className="col-md-3 col-form-label"
                      >
                        Nama Pangkat <span className="text-danger">*</span>
                      </label>
                      <Col md="5">
                        <AvField
                          name="rank_name"
                          placeholder="Nama Pangkat..."
                          type="text"
                          errorMessage="Masukkan Nama Pangkat"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_name"
                          value={this.state.dataForm.rank_name}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="rank_group"
                        className="col-md-3 col-form-label"
                      >
                        Golongan Angka <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="rank_group"
                          placeholder="Golongan Angka..."
                          type="number"
                          errorMessage="Masukkan Golongan Angka"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_group"
                          value={this.state.dataForm.rank_group}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="rank_group_code"
                        className="col-md-3 col-form-label"
                      >
                        Golongan Romawi <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="rank_group_code"
                          placeholder="Golongan Romawi..."
                          type="text"
                          errorMessage="Masukkan Golongan Romawi"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_group_code"
                          value={this.state.dataForm.rank_group_code}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="rank_room"
                        className="col-md-3 col-form-label"
                      >
                        Ruang <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="rank_room"
                          placeholder="Ruang..."
                          type="text"
                          errorMessage="Masukkan Ruang"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_room"
                          value={this.state.dataForm.rank_room}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="rank_group_room"
                        className="col-md-3 col-form-label"
                      >
                        Golongan/Ruang <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="rank_group_room"
                          placeholder="Golongan/Ruang..."
                          type="text"
                          errorMessage="Masukkan Golongan/Ruang"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="rank_group_room"
                          value={this.state.dataForm.rank_group_room}
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row> */}
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="?">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/master/pangkat_pppk.html?" />
        ) : null}
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
